import React from 'react'
import BecomeCounselor from './BecomeCounselor';
import FAQ from './FAQ'
import StudentTestimonial from './StudentTestimonial';
import WhyJoinUs from './WhyJoinUs'

export default function Counselor() {
    return (
        <div className='bg-slate-50'>
            <BecomeCounselor />
            <WhyJoinUs />
            <StudentTestimonial />
            <FAQ />
        </div>
    )
}
